import helpers from './helpers.js'

function plugin (Vue, options) {
  // Exit if the plugin has already been installed.
  if (plugin.installed) return

  // Extend `Vue.prototype` to include our global event bus.
  Object.defineProperty(Vue.prototype, '$helpers', {
    get () {
      return helpers
    }
  })
}

// Check for `window.Vue`
if (typeof window !== 'undefined' && window.Vue) {
    // Install plugin automatically.
    window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/thp-helpers/index.js